import { Roles } from '../utils';

export const getCurrentProject = (app) => {
  const { user, currentProjectId } = app;
  if (!user || !user.projects) {
    return null;
  }

  const [project] = user.projects.filter(i => i.id === currentProjectId);

  return project || null;
};

export const userRoleInCurrentProject = (app) => {
  const { roles, user } = app;

  if (user.super_admin) {
    return Roles.role_super_admin.id;
  }

  const project = getCurrentProject(app);

  if (project && project.role_id) {
    const [role] = roles.filter(i => i.id === project.role_id);
    return role ? role.code : null;
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/selectors/app.js